<h2 class="activity-header">{{ l(day.workDay | humanizeDate) }}</h2>

<div class="row" *ngFor="let activityDay of activityDays">
    <div class="col-sm-12 col-md-6 d-flex justify-content-between mt-5">
        <div
            class="d-inline-flex flex-column activity-data width-percent-100"
            [ngClass]="{ 'has-dot': activityDay.isCompleteToBeSubmitted }"
        >
            <div
                class="d-flex flex-row cursor-pointer"
                (click)="
                    toggleActivityDayDetailsSection(activityDay.activityDayId,!activityDay.isOpen)
                "
            >
                <div
                    *ngIf="
                        activityDay.isCompleteToBeSubmitted ||
                        activityDay.isCompleteToBeEnrolled
                    "
                >
                    <i
                        class="fa fa-circle activity-data__dot d-block"
                        aria-hidden="true"
                        *ngIf="activityDay.isCompleteToBeEnrolled"
                    >
                    </i>
                    <i
                        class="fas fa-check activity-data__check d-block"
                        aria-hidden="true"
                        *ngIf="activityDay.isCompleteToBeSubmitted"
                    >
                    </i>
                </div>
                <div>
                    <div class="activity-data__asset">
                        <span>{{ activityDay.detailedActivity?.controllingStructureCode }}</span>
                    </div>
                    <div class="activity-data__name">
                        {{ activityDay.name }}
                    </div>
                    <div
                        class="d-flex flex-wrap flex-column activity-data__subname"
                    >
                        <div class="d-flex mb-1">
                            <span class="mr-2"> {{ l("People") }}: </span>
                            <span *ngIf="activityDay.detailedActivity">
                                {{ activityDay.detailedActivity.allocatedPersonnel.allocatedPersonnelHours }} hrs
                            </span>
                            <span *ngIf="!activityDay.detailedActivity">
                                {{ activityDay.allocatedPersonnelHours }} hrs
                            </span>
                        </div>
                        <div class="d-flex mb-1">
                            <span class="mr-2"> {{ l("Plant") }}: </span>
                            <span *ngIf="activityDay.detailedActivity">
                                {{ activityDay.detailedActivity.allocatedPlants.allocatedPlantsHours }} hrs
                            </span>
                            <span *ngIf="!activityDay.detailedActivity">
                                {{ activityDay.allocatedPlantsHours }} hrs
                            </span>
                        </div>
                        <div class="d-flex mb-1">
                            <span class="mr-2"> {{ l("Material") }}: </span>
                            <span *ngIf="activityDay.detailedActivity">
                                {{ activityDay.detailedActivity.allocatedMaterials.allocatedMaterialsHours }} hrs
                            </span>
                            <span *ngIf="!activityDay.detailedActivity">
                              {{ activityDay.allocatedMaterialsHours }} hrs
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div
                *ngIf="activityDay.isOpen"
                style="padding-left: 18px"
            >
                <div
                    class="mt-5 pt-3"
                    *ngIf="
                        activityDay.activitySourceDetails
                            .isWorkPlanExecutionEditable
                    "
                >
                    <label class="bold">{{
                        l("VarianceFromPlanReason")
                    }}</label>
                    <app-variance-from-plan
                        [controlDisabled]="
                            activityDay.isSubmitted ||
                            !isGranted('Pages.AllocationSheets.Edit')
                        "
                        [variancesFromPlanReasons]="variancesFromPlanReasons"
                        [workPlanExecution]="activityDay.workPlanExecution"
                        [activityDayId]="activityDay.activityDayId"
                        (onVarianceUpdated)="
                            checkCompleteToBeSubmitted(activityDay)
                        "
                    >
                    </app-variance-from-plan>
                </div>
                <div class="mt-5 pt-3">Photo evidence - soon</div>
            </div>
        </div>

        <div class="d-inline-flex align-items-baseline">
            <button
                class="btn cursor-pointer"
                (click)="
                    toggleActivityDayDetailsSection(activityDay.activityDayId,!activityDay.isOpen)
                "
            >
                <i
                    class="fa"
                    [title]="activityDay.isOpen?'Show less':'Show more'"
                    [ngClass]="{
                        'fa-chevron-down':
                            !activityDay.isOpen,
                        'fa-chevron-up': activityDay.isOpen
                    }"
                ></i>
            </button>

            <div class="btn-group dropdown" dropdown container="body">
                <button class="btn btn-sm" dropdownToggle>
                    <i class="fas fa-ellipsis-h"></i>
                </button>

                <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
                    <li class="dropdown-item cursor-pointer">
                        <button
                            (click)="
                                removeFromAllocation(
                                    allocationSheetId,
                                    activityDay.activityDayId
                                )
                            "
                            class="btn btn-sm"
                            [disabled]="activityDay && activityDay.isSubmitted || !isGranted('Pages.AllocationSheets.Edit')"
                        >
                            {{ l("RemoveFromAllocation") }}
                        </button>
                    </li>
                    <ng-container *ngIf="isGranted('Pages.AllocationSheets.Edit')">
                        <li class="dropdown-item cursor-pointer" 
                        (click)="openEdit(activityDay.activityDayId)">
                            <button class="btn btn-sm">
                                {{ l("Edit") }}
                            </button>
                        </li>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>

    <div class="col-sm-12 col-md-6">
        <div *ngIf="activityDay.isOpen">
            <div class="mt-5">
                <label
                    ><b>{{ l("People") }}</b></label
                >
                <app-assign-personnel
                    *ngIf="activityDay.detailedActivity"
                    [componentMode]="'allocationSheet'"
                    [allocatedPersonnel]="activityDay.detailedActivity.allocatedPersonnel"
                    [activityDayId]="activityDay.activityDayId"
                    (showActivityPanel)="openActivityEditPanel(activityDay.activityDayId)"
                    [anyResourceSelected]="isAnyResouceSelected(activityDay.activityDayId)"
                >
                </app-assign-personnel>
            </div>

            <div class="mt-5">
                <label
                    ><b>{{ l("Plants") }}</b></label
                >
                <app-assign-plants
                    *ngIf="activityDay.detailedActivity"
                    [componentMode]="'allocationSheet'"
                    [activityDayId]="activityDay.activityDayId"
                    [allocatedPlants]="activityDay.detailedActivity.allocatedPlants"
                    (showActivityPanel)="openActivityEditPanel(activityDay.activityDayId)"
                    [anyResourceSelected]="isAnyResouceSelected(activityDay.activityDayId)"
                >
                </app-assign-plants>
                
            </div>

            <div class="mt-5">
                <label
                    ><b>{{ l("Material") }}</b></label
                >
                <app-assign-materials
                    *ngIf="activityDay.detailedActivity"
                    [componentMode]="'allocationSheet'"
                    [activityDayId]="activityDay.activityDayId"
                    [allocatedMaterials]="activityDay.detailedActivity.allocatedMaterials"
                    (showActivityPanel)="openActivityEditPanel(activityDay.activityDayId)"
                    [anyResourceSelected]="isAnyResouceSelected(activityDay.activityDayId)"
                >
                </app-assign-materials>
                
            </div>
        </div>
    </div>
</div>
